export type TokenPayload = {
  exp: number
  app_id: string
  at_hash: string
  aud: string
  device_id: string
  email: string
  family_name: string
  given_name: string
  isAnonymous: string
  iss: string
  partner_id: string
  relation_id: string
  simulation_mode: string
  simulation_owner: string
  unique_name: string
}

export const isTokenExpired = (payload: TokenPayload): boolean => {
  if (typeof payload === 'object' && payload?.exp) {
    const date = new Date(payload.exp * 1000)
    return date < new Date()
  }

  return true
}
